import * as Yup from "yup";

// Login Page Schema
export const loginSchema = Yup.object().shape({
  username: Yup.string()
    .min(3, "حداقل باید سه کاراکتر باشد")
    .required("نام کاربری اجباری می باشد"),
  password: Yup.string()
    .min(6, "رمز ورود نمی تواند کوچکتر از 6 حرف باشد")
    .required("رمز عبور را وارد نمایید"),
});

// Forgot Password Schema
export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email("ایمیل نامعتبر می باشد")
    .required("ایمیل اجباری می باشد"),
});

// change password Schema
export const changePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string()
    .required("این فیلد اجباری می باشد")
    .min(6, "حداقل باید 6 کاراکتر باشد"),
  newPassword: Yup.string()
    .required("این فیلد اجباری می باشد")
    .min(6, "حداقل باید 6 کاراکتر باشد"),
  confirmPassword: Yup.string()
    .required("این فیلد اجباری می باشد")
    .min(6, "حداقل باید 6 کاراکتر باشد"),
});

// Register Schema
export const registerSchema = Yup.object({
  firstname: Yup.string()
    .required("نام اجباری می باشد")
    .min(3, "حداقل باید سه کاراکتر باشد"),
  lastname: Yup.string()
    .required("نام خانوادگی اجباری می باشد")
    .min(3, "حداقل باید سه کاراکتر باشد"),
  username: Yup.string().required("نام کاربری اجباری می باشد"),
  email: Yup.string()
    .email("ایمیل نامعتبر می باشد")
    .required("ایمیل اجباری می باشد"),
  mobile: Yup.string()
    .matches(/^(\+98|0)?9\d{9}$/, "شماره موبایل نامعتبر است")
    .required("شماره موبایل اجباری می باشد"),
  password: Yup.string()
    .required("رمز عبور اجباری می باشد")
    .min(6, "رمز ورود نمی تواند کوچکتر از 6 حرف باشد"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "پسورد و تکرار آن باید یکسان باشند")
    .required("تکرار رمز عبور اجباری می باشد"),
});
